export const VALUE_SET = 'character.VALUE_SET';
export const VALUE_SET_COMMIT = 'character.VALUE_SET_COMMIT';
export const VALUE_REMOVE = 'character.VALUE_REMOVE';
export const VALUE_REMOVE_COMMIT = 'character.VALUE_REMOVE_COMMIT';
export const ENTITY_VALUES_REMOVE = 'character.ENTITY_VALUES_REMOVE';
export const ENTITY_VALUES_REMOVE_COMMIT = 'character.ENTITY_VALUES_REMOVE_COMMIT';
